import React from 'react';
import clsx from 'clsx';
import styles from './SphereLoader.scss';
export function SphereLoader(_ref) {
  let {
    className,
    size
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.loader, className),
    style: {
      width: size,
      height: size
    },
    "aria-label": "Loading",
    role: "status"
  });
}
//# sourceMappingURL=SphereLoader.js.map